import {
  LOT_TYPES,
  SESSION_TYPES,
  SESSION_STATUSES,
  PARTICIPANT_TYPES,
  LOT_STATUSES,
  USER_TYPES,
  SUBSCRIPTION_TYPES,
  DOCUMENT_STATUSES,
  REQUEST_STATUSES,
  ORG_REQUEST_STATUSES,
  LOT_REQUEST_STATUSES,
  ORGANIZATION_TABS,
  USER_TABS,
  LOT_TABS,
  DOCUMENT_TYPES,
  TRADE_DIRECTION_TYPES,
  LOT_REQUEST_TYPES,
  TRADE_RESULT_TYPES,
  SESSION_LOCK_STATUSES,
  PREMIUM_TYPES,
  STATIC_FILE_TYPES,
  ORGANIZATION_TYPES,
  DOCUMENT_PERSON_IDENTITY_TYPES,
  PAYMENT_PURPOSE_TYPES,
  BANK_ACCOUNT_TYPES
} from './business'

export const BANK_ACCOUNT_TYPES_ENUM = Object.freeze({
  [BANK_ACCOUNT_TYPES.CREDIT]: 'Счет в кредитной организации',
  [BANK_ACCOUNT_TYPES.FEDERAL]: 'Счет в территориальном органе Федерального казначейства/финансовом органе субъекта РФ или муниципальном образовании'
})

export const PAYMENT_PURPOSE_TYPES_ENUM = Object.freeze({
  [PAYMENT_PURPOSE_TYPES.ACCESS_PAYMENT]: 'Плата за доступ в СЭТ ВР',
  [PAYMENT_PURPOSE_TYPES.PAYMENT_FOR_INFORMATION]: 'Оплата сбора за получение информации, способствующей заключению Договора'
})

export const DOCUMENT_PERSON_IDENTITY_TYPES_ENUM = Object.freeze({
  [DOCUMENT_PERSON_IDENTITY_TYPES.PASSPORT]: 'Общегражданский паспорт',
  [DOCUMENT_PERSON_IDENTITY_TYPES.BIRTH_CERTIFICATE]: 'Свидетельство о рождении',
  [DOCUMENT_PERSON_IDENTITY_TYPES.INTERNATIONAL_PASSPORT]: 'Загранпаспорт гражданина РФ (для граждан РФ, постоянно проживающих за пределами территории РФ)',
  [DOCUMENT_PERSON_IDENTITY_TYPES.MILITARY_ID]: 'Удостоверение личности военнослужащего РФ; военный билет солдата, матроса, сержанта, старшины, прапорщика и мичмана',
  [DOCUMENT_PERSON_IDENTITY_TYPES.RUSSIAN_TEMPORARY_IDENTITY_CARD]: 'Временное удостоверение личности гражданина Российской Федерации (форма N 2П)',
  [DOCUMENT_PERSON_IDENTITY_TYPES.SAILOR_ID]: 'Удостоверение личности моряка',
  [DOCUMENT_PERSON_IDENTITY_TYPES.RESIDENCE_PERMIT]: 'Вид на жительство'
})

export const PARTICIPANT_TYPE_ADMIN_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.ORGPART]: 'Организатор и Участник',
  [PARTICIPANT_TYPES.ADMINISTRATOR]: 'Администратор'
})

export const PREMIUM_TYPE_ENUM = Object.freeze({
  [PREMIUM_TYPES.FIX]: 'Фиксированная цена'
})

export const ORGANIZATION_TYPE_ENUM = Object.freeze({
  [ORGANIZATION_TYPES.LEGAL]: 'Юридическое лицо',
  [ORGANIZATION_TYPES.INDIVIDUAL]: 'Индивидуальный предприниматель'
})

export const PARTICIPANT_TYPE_EDIT_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.ORGPART]: 'Организатор и Участник'
})

export const PARTICIPANT_TYPE_ROUTE_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.ORGPART]: 'Организатор и Участник'
})

export const PARTICIPANT_TYPE_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.UNKNOWN]: 'Неизвестно',
  [PARTICIPANT_TYPES.ORGPART]: 'Организатор и Участник',
  [PARTICIPANT_TYPES.NONE]: 'Статус снят',
  [PARTICIPANT_TYPES.ADMINISTRATOR]: 'Администратор'
})

export const PARTICIPANT_TYPE_TIP_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.ORGPART]: 'Юридическое лицо, действующее на ЭП от своего имени и за свой счет, имеющий право организовывать Торги по торговой процедуре и участвовать в торгах в соответствии с Регламентом',
  [PARTICIPANT_TYPES.ADMINISTRATOR]: 'Администратор'
})

export const SUBSCRIPTIONS_TYPE_ENUM = Object.freeze({
  [SUBSCRIPTION_TYPES.FULL]: 'Все подписки включены',
  [SUBSCRIPTION_TYPES.PARTIAL]: 'Есть подписки',
  [SUBSCRIPTION_TYPES.NONE]: 'Подписки отключены'
})

// export const ORGANIZATION_TYPE_ENUM = Object.freeze({
//   [ORGANIZATION_TYPES.LEGAL]: 'Юридическое лицо',
//   [ORGANIZATION_TYPES.INDIVIDUAL]: 'Индивидуальный предприниматель'
// })

export const STATUS_ENUM = Object.freeze({
  [DOCUMENT_STATUSES.INPROCESS]: 'В обработке',
  [DOCUMENT_STATUSES.APPROVED]: 'Одобрен',
  [DOCUMENT_STATUSES.DISABLED]: 'Отказано'
})

export const REQUEST_STATUS_ENUM = Object.freeze({
  [REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  [REQUEST_STATUSES.INPROCESS]: 'В обработке',
  [REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const ORG_REQUEST_STATUS_ENUM = Object.freeze({
  [ORG_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  [ORG_REQUEST_STATUSES.INPROCESS]: 'В обработке у Администратора',
  [ORG_REQUEST_STATUSES.REJECTED]: 'Отклонен Администратором',
  [ORG_REQUEST_STATUSES.APPROVED]: 'Одобрен Администратором'
})

export const ORG_REQUEST_STATUS_SHORT_ENUM = Object.freeze({
  [ORG_REQUEST_STATUSES.INPROCESS]: 'В обработке у Администратора',
  [ORG_REQUEST_STATUSES.REJECTED]: 'Отклонен Администратором',
  [ORG_REQUEST_STATUSES.APPROVED]: 'Одобрен Администратором'
})

export const LOT_REQUEST_STATUS_ENUM = Object.freeze({
  [LOT_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  [LOT_REQUEST_STATUSES.INPROCESS]: 'В обработке',
  [LOT_REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [LOT_REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const LOT_REQUEST_STATUS_SHORT_ENUM = Object.freeze({
  [LOT_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  // [LOT_REQUEST_STATUSES.INPROCESS]: 'В обработке',
  // [LOT_REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [LOT_REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const LOT_TYPE_ENUM = Object.freeze({
  [LOT_TYPES.REQUEST_OFFERS]: 'Приглашение делать ценовые предложения [открытая форма подачи ценовых предложений]',
  [LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME]: 'Приглашение делать ценовые предложения [делимый объем]'
})

export const SESSION_TYPE_ENUM = Object.freeze({
  [SESSION_TYPES.PUBLIC_OFFERS]: 'Открытая по форме подачи ценовых предложений',
  [SESSION_TYPES.PRIVATE_OFFERS]: 'Закрытая по форме подачи ценовых предложений',
  [SESSION_TYPES.PUBLIC_OFFERS_DIVISIBLE_VOLUME]: 'Открытая по форме подачи ценовых предложений [делимый объем]'
})

export const SESSION_STATUSES_ENUM = Object.freeze({
  [SESSION_STATUSES.DRAFT]: 'Черновик',
  [SESSION_STATUSES.REGISTERED]: 'Зарегистрирована'
})

export const STATIC_FILE_TYPE_ENUM = Object.freeze({
  [STATIC_FILE_TYPES.PICTURE]: 'Картинки',
  [STATIC_FILE_TYPES.DOC]: 'Документы'
})

export const ORGANIZATION_TABS_ENUM = Object.freeze({
  [ORGANIZATION_TABS.GENERAL_INFO]: 'Общая информация',
  [ORGANIZATION_TABS.BANK_ACCOUNTS]: 'Банковские реквизиты',
  [ORGANIZATION_TABS.CONTRACT]: 'Информация по договору',
  [ORGANIZATION_TABS.DOCUMENTS]: 'Документы'
})

export const ORGANIZATION_TABS_ADMIN_ENUM = Object.freeze({
  [ORGANIZATION_TABS.GENERAL_INFO]: 'Общая информация',
  [ORGANIZATION_TABS.USERS]: 'Уполномоченные представители',
  [ORGANIZATION_TABS.BANK_ACCOUNTS]: 'Банковские реквизиты',
  [ORGANIZATION_TABS.CONTRACT]: 'Информация по договору',
  [ORGANIZATION_TABS.DOCUMENTS]: 'Документы'
})

export const USER_TABS_ENUM = Object.freeze({
  [USER_TABS.USER_INFO]: 'Общая информация',
  [USER_TABS.PROXIES]: 'Документы',
  [USER_TABS.SUBSCRIPTIONS]: 'Подписки'
})

export const LOT_TABS_ENUM = Object.freeze({
  [LOT_TABS.GENERAL_INFO]: 'Общая информация',
  [LOT_TABS.LOT_DOCUMENTS]: 'Документы и разъяснения',
  [LOT_TABS.TRADE_PROCESS_DOCUMENTATION]: 'Итоги торгов',
  [LOT_TABS.TRADE_PROCESS]: 'Процесс торгов',
  [LOT_TABS.ORDERS]: 'Список предложений',
  [LOT_TABS.TRADE_RESULTS]: 'Результаты торгов',
  [LOT_TABS.LOT_REQUESTS]: 'Запросы по торговой процедуре'
})

export const TRADE_PROCESS_DOCUMENTATION_ENUM = Object.freeze({
  [DOCUMENT_TYPES.NOTES]: 'Примечания',
  [DOCUMENT_TYPES.REGISTRY]: 'Реестр ценовых предложений',
  [DOCUMENT_TYPES.OFFERER_NOTIFICATION]: 'Уведомление оферентам'
})

export const DOCUMENT_TYPE_ENUM = Object.freeze({
  ...TRADE_PROCESS_DOCUMENTATION_ENUM,
  [DOCUMENT_TYPES.CLARIFICATION]: 'Разъяснение по торговой процедуре',
  [DOCUMENT_TYPES.OFFER_CLIENT_PROXY]: 'Доверенность от клиента',
  [DOCUMENT_TYPES.NOTES]: 'Примечания',
  [DOCUMENT_TYPES.DOCUMENTATION]: 'Документация о торгах',
  [DOCUMENT_TYPES.CONTRACT]: 'Договор',
  [DOCUMENT_TYPES.NOTICE]: 'Извещение о торгах',
  [DOCUMENT_TYPES.OTHER_DOCUMENTS]: 'Иные документы',
  [DOCUMENT_TYPES.STATEMENT]: 'Заявление на отзыв торговой процедуры',
  [DOCUMENT_TYPES.USER_PROXY]: 'Доверенность на Уполномоченного представителя Пользователя СЭТ ВР',
  [DOCUMENT_TYPES.USER_STATEMENT]: 'Заявление на регистрацию Уполномоченного представителя Пользователя СЭТ ВР',
  [DOCUMENT_TYPES.ORGANIZATION_PROXY]: 'Доверенность на регистрацию организации',
  [DOCUMENT_TYPES.ORGANIZATION_KP_IMPLEMETATION_REPORT]: 'Отчет о реализации КП',
  [DOCUMENT_TYPES.ORGANIZATION_KP_VALIDATION_REPORT]: 'Отчет о валидации КП',
  [DOCUMENT_TYPES.ORGANIZATION_KP_AFFILIATION_INFORMATION]: 'Сведения об отраслевой принадлежности КП',
  [DOCUMENT_TYPES.ORGANIZATION_KP_VALIDATORS_AND_VERIFIERSINFORMATION]: 'Информация о валидаторах/ верификаторах КП',
  [DOCUMENT_TYPES.ORGANIZATION_KP_ACCREDITATION_VERIFIEDINFORMATION]: 'Информация об использовании аккредитованной/ верифицированной методике реализации КП',
  [DOCUMENT_TYPES.ORGANIZATION_STATEMENT_OF_ACCOUNT_IN_CARBON_UNUT_REGISTRY]: 'Выписка со счета в Реестре углеродных единиц'
})

export const TRADE_DIRECTION_TYPE_ENUM = Object.freeze({
  [TRADE_DIRECTION_TYPES.RAISING]: 'На повышение цены',
  [TRADE_DIRECTION_TYPES.LOWERING]: 'На понижение цены'
})

export const LOT_REQUEST_TYPE_ENUM = Object.freeze({
  [LOT_REQUEST_TYPES.REGISTRATION]: 'Регистрация торговой процедуры',
  [LOT_REQUEST_TYPES.SESSION_REGISTRATION]: 'Регистрация повторных торговых сессий',
  [LOT_REQUEST_TYPES.RECALL]: 'Отзыв торговой процедуры',
  [LOT_REQUEST_TYPES.CHANGE_DOCUMENTS]: 'Изменения в документации торговой процедуры',
  [LOT_REQUEST_TYPES.CONTRACT_CONDITION_FAIL]: 'Подача уведомления о неисполнении договора'
})

export const LOT_STATUS_TYPE_ENUM = Object.freeze({
  [LOT_STATUSES.DRAFT]: 'Черновик',
  [LOT_STATUSES.REGISTERED]: 'Объявлена',
  [LOT_STATUSES.FINISHED]: 'Завершена',
  [LOT_STATUSES.RECALLED]: 'Отозвана'
})

export const LOT_STATUS_TYPE_SHORT_ENUM = Object.freeze({
  [LOT_STATUSES.REGISTERED]: 'Объявлена',
  [LOT_STATUSES.FINISHED]: 'Завершена',
  [LOT_STATUSES.RECALLED]: 'Отозвана'
})

export const USER_LIST_TABS_ENUM = Object.freeze({
  [USER_TYPES.REGISTERED]: 'Зарегистрированные',
  [USER_TYPES.UNREGISTERED]: 'Незарегистрированные'
})

export const TRADE_RESULT_TYPE_FILTER_ENUM = Object.freeze({
  [TRADE_RESULT_TYPES.FAILED]: 'Торги не состоялись',
  [TRADE_RESULT_TYPES.WINNER_SELECTED]: 'Победитель определен.'
})

export const TRADE_RESULT_TYPE_FULL_VOLUME_ENUM = Object.freeze({
  [TRADE_RESULT_TYPES.UNSET]: 'Итог еще не определен.',
  [TRADE_RESULT_TYPES.FAILED]: 'Торги не состоялись',
  [TRADE_RESULT_TYPES.NO_ORDERS]: 'Нет ценовых предложений',
  [TRADE_RESULT_TYPES.ONE_PARTICIPANT_AGREED]: 'Единственный участник согласился.',
  [TRADE_RESULT_TYPES.WINNER_SELECTED]: 'Победитель определен.'
})

export const TRADE_RESULT_TYPE_DIVISIBLE_VOLUME_ENUM = Object.freeze({
  [TRADE_RESULT_TYPES.UNSET]: 'Итог еще не определен.',
  [TRADE_RESULT_TYPES.FAILED]: 'Торги не состоялись',
  [TRADE_RESULT_TYPES.NO_ORDERS]: 'Нет ценовых предложений',
  [TRADE_RESULT_TYPES.WINNER_SELECTED]: 'Победитель определен.',
  [TRADE_RESULT_TYPES.ONE_PARTICIPANT_AGREED]: 'Единственный участник согласился.',
  [TRADE_RESULT_TYPES.NO_ORGANIZER_OFFER]: 'Нет предложений от организатора.'
})

export const SESSION_LOCK_STATUS_ENUM = Object.freeze({
  [SESSION_LOCK_STATUSES.UNLOCKED]: 'Торги разрешены',
  [SESSION_LOCK_STATUSES.LOCKED_BY_END_SESSION_TIME_MAX]: 'Сессия завершена по времени.'
})

export const SET_UNSET_ENUM = Object.freeze({
  true: 'Да',
  false: 'Нет'
})

export const LOT_TEMPLATE_TABS_ENUM = Object.freeze({
  [LOT_TABS.GENERAL_INFO]: 'Общая информация'
})
